import Vue from "vue";
import VueRouter, { Route, RouteConfig } from "vue-router";

import AuthLayout from "@/layouts/AuthLayout.vue";
import AppLayout from "@/layouts/AppLayout.vue";

import { AuthRouter } from "@/features/auth/AuthRouter";
import { CompanyRouter } from "@/features/company/CompanyRouter";
import { UserRouter } from "@/features/user/UserRouter";
import { ModelRouter } from "@/features/model/ModelRouter";
import { DashboardRouter } from "@/features/dashboard/DashboardRouter";
import { AskCenAiRouter } from "@/features/askCenAi/AskCenAiRouter";
import { RvsCalculationRouter } from "@/features/rvsCalculation/RvsCalculationRouter";

Vue.use(VueRouter);

const loginGuard = (next: any, to: Route): boolean => {
  const hasAccessToken = Vue.prototype.$dep.httpClient.hasAccessToken();

  if (!hasAccessToken) {
    next({ name: "AuthLoginPage" });
  }

  if (hasAccessToken && to.path === "/") {
    next({ path: "/companies" });
  }

  return !hasAccessToken;
};

const routes: Array<RouteConfig> = [
  { path: "/auth", component: AuthLayout, children: [...AuthRouter()] },
  {
    path: "/",
    component: AppLayout,
    children: [
      ...ModelRouter(),
      ...CompanyRouter(),
      ...UserRouter(),
      ...DashboardRouter(),
      ...AskCenAiRouter(),
      ...RvsCalculationRouter(),
    ],
    beforeEnter: (to, from, next) => {
      if (loginGuard(next, to)) return;
      next();
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
